module.exports = __webpack_public_path__ + "img/product_67.a9d6d79.svg";